var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeatingpump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9295 19.4107C18.9792 20.4593 17.603 20.787 15.9974 19.3124C14.785 18.1984 14.3262 15.7407 14.1624 14.6266C14.0641 14.6594 13.933 14.6922 13.802 14.6922C13.6381 14.6922 13.4743 14.6594 13.376 14.5611C12.7862 15.5769 11.5083 17.5102 10.0337 18.0673C8.00215 18.8537 6.85531 18.0673 6.3638 16.7238C5.87229 15.3803 6.16719 14.0369 8.19877 13.2505C9.64053 12.6934 11.7704 13.2504 12.9173 13.6108C12.95 13.3159 13.1466 13.0866 13.4088 12.9556C12.8845 11.8415 12.0981 9.87537 12.4257 8.40084C12.9173 6.27096 14.1952 5.77947 15.5714 6.07438C16.9477 6.40206 17.8979 7.38504 17.4391 9.51492C17.1115 10.9895 15.5059 12.464 14.5557 13.2177C14.654 13.3487 14.7194 13.5453 14.7194 13.7091C14.7194 13.8074 14.7195 13.9058 14.6867 14.0041C15.8008 14.0697 18.2584 14.299 19.5035 15.4458C21.1091 16.9203 20.8798 18.2966 19.9295 19.3451M13.8348 5.1897C9.08349 5.1897 5.21692 9.05617 5.21692 13.8074C5.21692 18.5587 9.08349 22.4253 13.8348 22.4253C18.586 22.4253 22.4526 18.5587 22.4526 13.8074C22.4526 9.05617 18.586 5.1897 13.8348 5.1897Z",
    fill: "#5CC244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1891 16.3634H33.3312M24.1891 11.8416H33.3312M24.1891 7.28687H33.3312",
    stroke: "#B4BDCA",
    strokeWidth: 2.09711,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.60004,
    y: 1,
    width: 36,
    height: 25,
    rx: 2,
    stroke: "#B4BDCA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeatingpump);
export default __webpack_public_path__ + "static/media/icon_heatingpump.f447ef53a9e09746e2bb452cb8399158.svg";
export { ForwardRef as ReactComponent };